import { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import Layout from "components/Layout";
import PageTitle from "components/text/PageTitle";
import SectionTitle from "components/text/SectionTitle";
import PageListContainer from "./PageListContainer";
import ButtonPrimaryIcon from "components/buttons/ButtonPrimaryIcon";
import RoundActionIcon from "components/buttons/RoundActionIcon";

import landingPagesIcon from "assets/img/icons/icons8-macbook.svg";
import plusIcon from "assets/img/icons/plus-sign.svg";
import plusWhiteIcon from "assets/img/icons/plus-sign-white.svg";
import returnIcon from "assets/img/icons/return-icon.svg";

const Pages = styled.div`
  position: relative;
  width: 100%;
  box-sizing: border-box;

  margin: 0 0 50px;
  padding: 0 28px;

  display: flex;
  flex-direction: column;

  @media (max-width: ${globalConstants.switchTablet}) {
    margin: 0;
    padding: 0;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const BackIconWrap = styled.div``;

const PagesOverview = styled.div`
  position: relative;
  width: 100%;
  padding: ${css.BOX_PADDING_PRIMARY};
  box-sizing: border-box;

  background: ${css.BLUE_BOX_GRADIENT};
  border-radius: ${css.BOX_RADIUS_PRIMARY};

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const Heading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const BoxTitle = styled.div`
  width: 100%;

  line-height: 130%;

  font-size: ${css.BOX_TITLE_FONT_SIZE};
  font-weight: ${css.BOX_TITLE_FONT_WEIGHT};
`;

const TitleIcon = styled.div`
  display: inline-block;
  padding-right: 6px;

  transform: translateY(4.5px);

  width: 26px;
  min-width: 26px;
`;

const Text = styled.div`
  line-height: 130%;
`;

const ButtonWrap = styled.div`
  display: flex;
`;

export default () => {
  const navigate = useNavigate();

  // set page Title
  useEffect(() => {
    document.title = "Landing Pages | Scalelup";
  }, []);

  return (
    <Layout>
      <Pages>
        <Header>
          <PageTitle>Landing Pages</PageTitle>
          <BackIconWrap>
            <RoundActionIcon
              icon={returnIcon}
              iconSize="16px"
              iconAlt="Return"
              onClick={() => navigate("/marketing-tools")}
            />
          </BackIconWrap>
        </Header>
        <PagesOverview>
          <TopContent>
            <Heading>
              <BoxTitle>
                <TitleIcon>
                  <img src={landingPagesIcon} style={{ width: "100%" }} />
                </TitleIcon>
                Lead Capture Pages
              </BoxTitle>
              <Text>
                Create your own Lead Capture Landing Page, complete with an
                opt-in form to collect your leads' contact information. Use this
                powerful tool to build your own mailing list. Choose from dozens
                of professionally crafted templates, designed to convert
                visitors into potential customers. These pages are built to
                facilitate easy customization. You can use them in your posts on
                Scalelup or anywhere else.
              </Text>
            </Heading>
            <ButtonWrap>
              <ButtonPrimaryIcon
                icon={plusIcon}
                iconHover={plusWhiteIcon}
                onClick={() => {
                  navigate("/landing-page-templates");
                }}
              >
                Create New Page
              </ButtonPrimaryIcon>
            </ButtonWrap>
          </TopContent>
        </PagesOverview>
        <SectionTitle>Your Landing Pages</SectionTitle>
        <PageListContainer />
      </Pages>
    </Layout>
  );
};
